import Util from '@/helper/Utility.js';

export function CouponModel() {
    this.actualPricePerUnit = null;
    this.agencyAddress = null;
    this.agencyCity = null;
    this.agencyCountry = null;
    this.agencyEmail = null;
    this.agencyFax = null;
    this.agencyId = null;
    this.agencyLogoUrl = null;
    this.agencyName = null;
    this.agencyTel = null;
    this.agencyWebsite = null;
    this.agencyZipCode = null;
    this.appId = null;
    this.appsVisibility = null;
    this.badgeJson = null;
    this.badges = null;
    this.bahtToPointsAppsVisibility = null;
    this.barcode = null;
    this.cancelDate = null;
    this.caption = null;
    this.categoryDetail = null;
    this.categoryId = null;
    this.categoryName = null;
    this.categorySequence = null;
    this.checkUserRedeemPeriod = null;
    this.condition = null;
    this.conditionAlert = null;
    this.conditionAlertId = null;
    this.conditionBahtOnly = null;
    this.conditionBahtOnlyEn = null;
    this.conditionEN = null;
    this.conditionPointsOnly = null;
    this.conditionPointsOnlyEn = null;
    this.coolDown = null;
    this.coolDownPerCard = null;
    this.createBy = null;
    this.createDate = null;
    this.currentDate = null;
    this.customCaption = null;
    this.customFacebookMessage = null;
    this.customInput = null;
    this.customizeGetSerial = null;
    this.customizeRedeem = null;
    this.customizeSettingJson = null;
    this.dayProceed = null;
    this.dayRemain = null;
    this.daysValidAfterExpire = null;
    this.defaultPrivilegeMessage = null;
    this.defaultPrivilegeMessageEn = null;
    this.defaultPrivilegeMessageFormat = null;
    this.delivered = null;
    this.deliveryJson = null;
    this.detail = null;
    this.detailBahtOnly = null;
    this.detailBahtOnlyEn = null;
    this.detailEn = null;
    this.detailPointsOnly = null;
    this.detailPointsOnlyEn = null;
    this.discount = null;
    this.distance = null;
    this.expireDate = null;
    this.extra = null;
    this.feePerUnit = null;
    this.fullImageUrl = null;
    this.giftUserOnly = null;
    this.giftable = null;
    this.id = null;
    this.isCheckUserCampaignPermission = null;
    this.isConditionPass = null;
    this.ssExcludeVat = null;
    this.isFavourite = null;
    this.isHighlight = null;
    this.isNotAutoUse = null;
    this.isRedeem = null;
    this.isRequirePoints = null;
    this.isRequireUniqueSerial = null;
    this.isShowNotiNearby = null;
    this.isSpecificLocation = null;
    this.isSpecificPrintVoucher = null;
    this.isSplitPointSystem = null;
    this.isSponsor = null;
    this.itemCountSold = null;
    this.keyword = null;
    this.lastRedeemDate = null;
    this.locationAgencyId = null;
    this.marketPlaceUserLevel = null;
    this.marketPlaceUserVisibility = null;
    this.masterCampaignId = null;
    this.masterCampaignName = null;
    this.merchantStatusId = null;
    this.minutesValidAfterUsed = null;
    this.name = null;
    this.nameBahtOnly = null;
    this.nameBahtOnlyEn = null;
    this.nameEn = null;
    this.namePointsOnly = null;
    this.namePointsOnlyEn = null;
    this.nameTh = null;
    this.nextRedeemDate = null;
    this.nextRedeemDatePerCard = null;
    this.notificationCount = null;
    this.originalPrice = null;
    this.otherPointPerUnit = null;
    this.otp = null;
    this.parentCampaignId = null;
    this.parentCategoryId = null;
    this.partialPoints = null;
    this.pictures = null;
    this.pointPerUnit = null;
    this.pointPerUnitConvert = null;
    this.pointType = null;
    this.pointsToBahtAppsVisibility = null;
    this.pricePerUnit = null;
    this.pricePlanDeliveryType = null;
    this.priceSold = null;
    this.promocodeCampaigns = null;
    this.qty = null;
    this.quantity = null;
    this.redeemCount = null;
    this.redeemCountInPeriod = null;
    this.redeemCountPerCard = null;
    this.redeemMedia = null;
    this.redeemMostPerCard = null;
    this.redeemMostPerCardInPeriod = null;
    this.redeemMostPerPerson = null;
    this.redeemMostPerPersonInPeriod = null;
    this.redeems = null;
    this.referenceCode = null;
    this.regularDeliveryCostPerUnit = null;
    this.related = null;
    this.score = null;
    this.serialCount = null;
    this.serialFormat = null;
    this.serialPrefix = null;
    this.sponsorCategoryName = null;
    this.startDate = null;
    this.statusId = null;
    this.subCampaigns = null;
    this.termsAndConditions = null;
    this.type = null;
    this.useCount = null;
    this.usePricePlan = null;
    this.usedCount = null;
    this.userLevel = null;
    this.voucherExpireDate = null;
    this.website = null;
    this.updated_points = null;
    this.updated_points_other = null;

    this.setDataFromApi = function(data) {
        this.actualPricePerUnit = data.ActualPricePerUnit;
        this.agencyAddress = data.AgencyAddress;
        this.agencyCity = data.AgencyCity;
        this.agencyCountry = data.AgencyCountry;
        this.agencyEmail = data.AgencyEmail;
        this.agencyFax = data.AgencyFAX;
        this.agencyId = data.AgencyID;
        this.agencyLogoUrl = data.AgencyLogoUrl;
        this.agencyName = data.AgencyName;
        this.agencyTel = data.AgencyTel;
        this.agencyWebsite = data.AgencyWebsite;
        this.agencyZipCode = data.AgencyZipCode;
        this.appId = data.AppID;
        this.appsVisibility = data.AppsVisibility;
        this.badgeJson = data.BadgeJson;
        this.badges = data.Badges;
        this.bahtToPointsAppsVisibility = data.BahtToPointsAppsVisibility;
        this.barcode = data.Barcode;
        this.cancelDate = data.CancelDate;
        this.caption = data.Caption;
        this.categoryDetail = data.CategoryDetail;
        this.categoryId = data.CategoryID;
        this.categoryName = data.CategoryName;
        this.categorySequence = data.CategorySequence;
        this.checkUserRedeemPeriod = data.CheckUserRedeemPeriod;
        this.condition = data.Condition;
        this.conditionAlert = data.ConditionAlert;
        this.conditionAlertId = data.ConditionAlertId;
        this.conditionBahtOnly = data.ConditionBahtOnly;
        this.conditionBahtOnlyEn = data.ConditionBahtOnlyEN;
        this.conditionEN = data.ConditionEN;
        this.conditionPointsOnly = data.ConditionPointsOnly;
        this.conditionPointsOnlyEn = data.ConditionPointsOnlyEN;
        this.coolDown = data.CoolDown;
        this.coolDownPerCard = data.CoolDownPerCard;
        this.createBy = data.CreateBy;
        this.createDate = data.CreateDate;
        this.currentDate = data.CurrentDate;
        this.customCaption = data.CustomCaption;
        this.customFacebookMessage = data.CustomFacebookMessage;
        this.customInput = data.CustomInput;
        this.customizeGetSerial = data.CustomizeGetSerial;
        this.customizeRedeem = data.CustomizeRedeem;
        this.customizeSettingJson = data.CustomizeSettingJson;
        this.dayProceed = data.DayProceed;
        this.dayRemain = data.DayRemain;
        this.daysValidAfterExpire = data.DaysValidAfterExpire;
        this.defaultPrivilegeMessage = data.DefaultPrivilegeMessage;
        this.defaultPrivilegeMessageEn = data.DefaultPrivilegeMessageEN;
        this.defaultPrivilegeMessageFormat = data.DefaultPrivilegeMessageFormat;
        this.delivered = data.Delivered;
        this.deliveryJson = data.DeliveryJson;
        this.detail = data.Detail;
        this.detailBahtOnly = data.DetailBahtOnly;
        this.detailBahtOnlyEn = data.DetailBahtOnlyEN;
        this.detailEn = data.DetailEN;
        this.detailPointsOnly = data.DetailPointsOnly;
        this.detailPointsOnlyEn = data.DetailPointsOnlyEN;
        this.discount = data.Discount;
        this.distance = data.Distance;
        this.expireDate = data.ExpireDate;
        this.extra = data.Extra;
        this.feePerUnit = data.FeePerUnit;
        this.fullImageUrl = Util.isEmptyStr(data.FullImageUrl) ? null : data.FullImageUrl + '-large';
        this.giftUserOnly = data.GiftUserOnly;
        this.giftable = data.Giftable;
        this.id = data.ID;
        this.isCheckUserCampaignPermission = data.IsCheckUserCampaignPermission;
        this.isConditionPass = data.IsConditionPass;
        this.ssExcludeVat = data.IsExcludeVat;
        this.isFavourite = data.IsFavourite;
        this.isHighlight = data.IsHighlight;
        this.isNotAutoUse = data.IsNotAutoUse;
        this.isRedeem = data.IsRedeem;
        this.isRequirePoints = data.IsRequirePoints;
        this.isRequireUniqueSerial = data.IsRequireUniqueSerial;
        this.isShowNotiNearby = data.IsShowNotiNearby;
        this.isSpecificLocation = data.IsSpecificLocation;
        this.isSpecificPrintVoucher = data.IsSpecificPrintVoucher;
        this.isSplitPointSystem = data.IsSplitPointSystem;
        this.isSponsor = data.IsSponsor;
        this.itemCountSold = data.ItemCountSold;
        this.keyword = data.Keyword;
        this.lastRedeemDate = data.LastRedeemDate;
        this.locationAgencyId = data.LocationAgencyId;
        this.marketPlaceUserLevel = data.MarketPlaceUserLevel;
        this.marketPlaceUserVisibility = data.MarketPlaceUserVisibility;
        this.masterCampaignId = data.MasterCampaignId;
        this.masterCampaignName = data.MasterCampaignName;
        this.merchantStatusId = data.MerchantStatusId;
        this.minutesValidAfterUsed = data.MinutesValidAfterUsed;
        this.name = data.Name;
        this.nameBahtOnly = data.NameBahtOnly;
        this.nameBahtOnlyEn = data.NameBahtOnlyEN;
        this.nameEn = data.NameEN;
        this.namePointsOnly = data.NamePointsOnly;
        this.namePointsOnlyEn = data.NamePointsOnlyEN;
        this.nameTh = data.NameTH;
        this.nextRedeemDate = data.NextRedeemDate;
        this.nextRedeemDatePerCard = data.NextRedeemDatePerCard;
        this.notificationCount = data.NotificationCount;
        this.originalPrice = data.OriginalPrice;
        this.otherPointPerUnit = data.OtherPointPerUnit;
        this.otp = data.Otp;
        this.parentCampaignId = data.ParentCampaignId;
        this.parentCategoryId = data.ParentCategoryID;
        this.partialPoints = data.PartialPoints;
        this.pictures = data.Pictures;
        this.pointPerUnit = data.PointPerUnit;
        this.pointPerUnitConvert = data.PointPerUnitConvert;
        this.pointType = data.PointType;
        this.pointsToBahtAppsVisibility = data.PointsToBahtAppsVisibility;
        this.pricePerUnit = data.PricePerUnit;
        this.pricePlanDeliveryType = data.PricePlanDeliveryType;
        this.priceSold = data.PriceSold;
        this.promocodeCampaigns = data.PromocodeCampaigns;
        this.qty = data.Qty;
        this.quantity = data.Quantity;
        this.redeemCount = data.RedeemCount;
        this.redeemCountInPeriod = data.RedeemCountInPeriod;
        this.redeemCountPerCard = data.RedeemCountPerCard;
        this.redeemMedia = data.RedeemMedia;
        this.redeemMostPerCard = data.RedeemMostPerCard;
        this.redeemMostPerCardInPeriod = data.RedeemMostPerCardInPeriod;
        this.redeemMostPerPerson = data.RedeemMostPerPerson;
        this.redeemMostPerPersonInPeriod = data.RedeemMostPerPersonInPeriod;
        this.redeems = data.Redeems;
        this.referenceCode = data.ReferenceCode;
        this.regularDeliveryCostPerUnit = data.RegularDeliveryCostPerUnit;
        this.related = data.Related;
        this.score = data.Score;
        this.serialCount = data.SerialCount;
        this.serialFormat = data.SerialFormat;
        this.serialPrefix = data.SerialPrefix;
        this.sponsorCategoryName = data.SponsorCategoryName;
        this.startDate = data.StartDate;
        this.statusId = data.StatusID;
        this.subCampaigns = data.SubCampaigns;
        this.termsAndConditions = data.TermsAndConditions;
        this.type = data.Type;
        this.useCount = data.UseCount;
        this.usePricePlan = data.UsePricePlan;
        this.usedCount = data.UsedCount;
        this.userLevel = data.UserLevel;
        this.voucherExpireDate = data.VoucherExpireDate;
        this.website = data.Website;
        this.updated_points = data.updated_points;
        this.updated_points_other = data.updated_points_other;
    };
}
